// this file is automatically generated by git.version.ts script
export default {
  'AppName': 'cjx-pos-manager',
  'version': '4.0.0',
  'commit': '5a13bd4',
  'branch': 'develop'
  ,'forceDomain': null
};